import React from 'react'
import { isMobile } from 'lib/device'
import Action from 'components/quests/Action'
import styles from 'components/panels/history-panel.module.scss'
import cn from 'classnames'
import useGetHistory from 'refactor/hooks/api/useGetHistory'
import SearchHeader from 'components/panels/SearchHeader'

function HistoryPanel(props) {
    const { actions } = useGetHistory()

    return (
        <div className={cn(styles.historyPanelComp, 'history-panel-comp', 'h100')}>
            {/* Spacer for clearance under the overlaid top bar; the caps label was removed. */}
            <div className={cn(styles.panelHeaderContainer)} />

            <div className={cn(styles.searchHeaderContainer, isMobile && 'full-bleed-quests')}>
                <SearchHeader />
            </div>

            <div className={cn(styles.actionContainer)}>
                {actions.map(action => {
                    return <Action key={action.id} action={action} />
                })}
            </div>
        </div>
    )
}

export default HistoryPanel
